'use strict';

/**
 * Groupon LazyLoad
 *
 * Version:  0.0.3
 *
 * Based on jQuery Lazy Load v1.9.3 by Mika Tuupola
 */
var $window, dealList, fixiOS5, getElementPositions, getFold, getImagesToLoad, getTouchDealCardHeight, progressiveLoad, setTouchImageDimensions, touchDealCardHeight, unbindLazyloaderEvent, withinViewport;

touchDealCardHeight = dealList = void 0;

$window = $(window);


/**
 * With IOS5 force loading images when navigating with back button.
 * Non optimal workaround.
 *
 * @param {Array} allLazyImages[] - All images to be lazyloaded
 */

fixiOS5 = function(allLazyImages) {
  if (/(?:iphone|ipod|ipad).*os 5/gi.test(navigator.appVersion)) {
    return $window.one('pageshow', function(event) {
      if (event.originalEvent && event.originalEvent.persisted) {
        return $(allLazyImages).trigger('appear');
      }
    });
  }
};


/**
 * Determine image positions within the document
 *
 * @param   {Array} images[] - Array with images nodes
 * @returns {Array} pos[]    - Array containing the current images position in the document
 */

getElementPositions = function(images) {
  var img, left, pos, ref, right, top;
  pos = [];
  images = images.slice();
  while ((img = images.shift())) {
    ref = img.getBoundingClientRect(), top = ref.top, left = ref.left, right = ref.right;
    pos.push({
      left: left,
      top: top,
      right: right
    });
  }
  return pos;
};


/**
 * Returns the top/bottom coordinate of the visible viewport in doc coords
 *
 * @returns {Object}
 */

getFold = function() {
  return {
    height: window.innerHeight,
    width: window.innerWidth
  };
};


/**
 * Filter out the `images` that are visible, but not yet loaded
 *
 * @param   {Array} images[] - Images to lazyload
 * @returns {Array} toLoad[] - Images that haven't been loaded
 */

getImagesToLoad = function(images) {
  var img, toLoad;
  toLoad = [];
  images = images.slice();
  while ((img = images.shift())) {
    if (!img.loaded && img.offsetHeight) {
      toLoad.push(img);
    }
  }
  return toLoad;
};


/**
 * Returns potential deal card height
 *
 * @returns {Number} height - Deal card height
 */

getTouchDealCardHeight = function() {
  var height;
  height = 0;
  if (typeof Touch !== "undefined" && Touch !== null ? Touch.Utils.getViewportInformation : void 0) {
    height = Touch.Utils.getViewportInformation({
      offset: dealList[0].offsetLeft * 2
    }).dcH;
  }
  return height;
};


/**
 * Sets html height attribute to touch dealcard images to speed up their rendering
 *
 * @param {Array} collection[] - Collection of images nodes
 */

setTouchImageDimensions = function(collection) {
  var i, img, len;
  window.removeEventListener('load', setTouchImageDimensions);
  if (!(dealList = document.querySelectorAll('.t-deals')).length) {
    return;
  }
  if ((touchDealCardHeight = getTouchDealCardHeight())) {
    for (i = 0, len = collection.length; i < len; i++) {
      img = collection[i];
      if (img.parentNode.parentNode.parentNode.className.match(/t-deals/)) {
        img.height = touchDealCardHeight;
      }
    }
  }
};


/**
 * Unbind the lazyloader event
 */

unbindLazyloaderEvent = function(settings) {
  if (settings.performantScroll) {
    $(settings.container).off(settings.event);
  }
};


/**
 * Determine if an images is within the viewport + threshold
 *
 * @param   {Object}  fold      - Viewport information
 * @param   {Object}  imgPos    - Image information
 * @param   {Number}  threshold - Threshold to consider loading images within
 * @returns {Boolean}
 */

withinViewport = function(fold, imgPos, threshold) {
  var left, right, top;
  left = imgPos.left, top = imgPos.top, right = imgPos.right;
  if (top <= -threshold) {
    return false;
  }
  if (top >= fold.height + threshold) {
    return false;
  }
  if (left <= -threshold) {
    return false;
  }
  if (right >= fold.width + threshold) {
    return false;
  }
  return true;
};


/*
 * progressive load image
 */

progressiveLoad = function(el, settings) {
  var highQualityImage, highQualitySrc;
  if (!el.loaded && $(el).hasClass('progressive-load')) {
    if ((settings.isRetina && (highQualitySrc = el.getAttribute('data-high-quality-2x'))) || (highQualitySrc = el.getAttribute('data-high-quality'))) {
      highQualityImage = new Image();
      highQualityImage.style.display = 'none';
      $(highQualityImage).on('load', function() {
        if (el.nodeName === 'IMG') {
          el.src = highQualitySrc;
        } else {
          el.style.backgroundImage = "url('" + highQualitySrc + "')";
        }
        el.style['-webkit-filter'] = 'blur(0px)';
        el.style['filter'] = 'blur(0px)';
        return el.parentNode.removeChild(this);
      });
      highQualityImage.src = highQualitySrc;
      el.parentNode.appendChild(highQualityImage);
    }
  }
  el.loaded = true;
};

(function(jQuery, window) {
  "use strict";
  return $.fn.lazyload = function(options) {
    var OPTS, allLazyImages, initLazyLoading, loadImage, onScroll, requestTick, resizeTimer, settings, ticking;
    if (options == null) {
      options = {};
    }
    allLazyImages = this.get();
    resizeTimer = null;
    OPTS = {
      event: 'scroll.lazyload',
      threshold: 400,
      skip_invisible: true,
      skip_initial_check: false,
      container: window,
      performantScroll: false,
      isRetina: window.devicePixelRatio && window.devicePixelRatio > 1,
      placeholder: "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="
    };
    settings = Object.assign({}, OPTS, options);
    if (settings.resetImageDimensions) {
      setTouchImageDimensions(allLazyImages);
      return;
    }
    ticking = false;

    /*
     * Global scroll handler
     */
    onScroll = function() {
      var fold, imagesNotLoaded, img, pos, positions, threshold;
      ticking = false;
      if (!settings.skip_invisible) {
        $(allLazyImages).trigger('appear');
        unbindLazyloaderEvent(settings);
        return;
      }
      imagesNotLoaded = getImagesToLoad(allLazyImages);
      if (!imagesNotLoaded.length) {
        unbindLazyloaderEvent(settings);
        return;
      }
      fold = getFold();
      allLazyImages = [];
      positions = getElementPositions(imagesNotLoaded);
      threshold = settings.threshold;
      while ((img = imagesNotLoaded.shift())) {
        pos = positions.shift();
        if (withinViewport(fold, pos, threshold)) {
          $(img).triggerHandler('appear');
        } else {
          allLazyImages.push(img);
        }
      }
    };

    /*
     * Image loading handler
     */
    loadImage = function() {
      var url, url2x;
      url = this.getAttribute('data-original');
      if (settings.isRetina && (url2x = this.getAttribute('data-original-2x'))) {
        url = url2x;
      }
      if (this.nodeName === 'IMG') {
        this.src = url;
      } else {
        this.style.backgroundImage = "url('" + url + "')";
      }
      progressiveLoad(this, settings);
      this.classList.remove('lazy-wl', 'lazy-load');
    };

    /*
     * Asynchronous scroll handler
     */
    requestTick = function() {
      if (!ticking) {
        requestAnimationFrame(onScroll);
        ticking = true;
      }
    };
    initLazyLoading = function(onScrollHandler) {
      var images, img;
      if (resizeTimer === null) {
        $window.on('resize', function() {
          if (resizeTimer) {
            clearTimeout(resizeTimer);
          }
          return resizeTimer = setTimeout(onScrollHandler, 100);
        });
      }
      images = allLazyImages.slice();
      while ((img = images.shift())) {
        if (img.nodeName === 'IMG' && img.src === '') {
          img.loaded = false;
          img.src = settings.placeholder;
        }
      }
      setTouchImageDimensions(allLazyImages);
      $(allLazyImages).one('appear', loadImage);
      fixiOS5(allLazyImages);
      window.removeEventListener('scroll', requestTick, {
        passive: true
      });
      window.addEventListener('scroll', requestTick, {
        passive: true
      });
      $(function() {
        if (!settings.skip_initial_check) {
          return requestTick();
        }
      });
      window.removeEventListener('load', setTouchImageDimensions(allLazyImages), {
        passive: true,
        once: true
      });
      return window.addEventListener('load', setTouchImageDimensions(allLazyImages), {
        passive: true,
        once: true
      });
    };
    return initLazyLoading(onScroll);
  };
})(jQuery, window);

module.exports = {
  getElementPositions: getElementPositions,
  getFold: getFold,
  getImagesToLoad: getImagesToLoad,
  getTouchDealCardHeight: getTouchDealCardHeight,
  setTouchImageDimensions: setTouchImageDimensions,
  withinViewport: withinViewport
};

